import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";

import TSListAdminAppoint from "../components/Forms/TSListAdminAppoint.js";
import TSListAdmin from "../components/Forms/TSListAdmin2.js";

// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";


//function Admin() {
const Admin = (props) => {
    const ServiceType = (props.match.params.ServiceType !== undefined) ? props.match.params.ServiceType : null;

    const [pills, setPills] = useState("2");
    const [teleItem, setTeleItem] = useState(null);


    useEffect(() => {
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    },[]);

    const currentUser = authenticationService.currentUserValue;
    console.log(currentUser)
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    } else if (currentUser.role == null) {
        return <Redirect to={{ pathname: '/home', /*state: { from: props.location }*/ }} />
    }

    return (
        <>
            <TSNavbar />
            <div className="wrapper">
                <TrangskinPageHeader2 />
                <div className="section" style={{ padding: '0' }}>
                    <Container>
                        
                          
                        <h3 className="title"> {(ServiceType == 'booking') ? "รายการนัดออนไลน์" : "รายการพบแพทย์ทางไกล Telemedicine" }</h3>
                       
                       {(ServiceType == 'booking') ? <TSListAdminAppoint /> : <TSListAdmin />}

                      
                        
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default Admin;

